function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M0 0H24V24H0z"
}), React.createElement("path", {
  fill: "#ED1C24",
  d: "M19 6h-3V5c0-.553-.447-1-1-1-.553 0-1 .447-1 1v1h-4V5c0-.553-.447-1-1-1-.553 0-1 .447-1 1v1H5c-.553 0-1 .447-1 1v12c0 .553.447 1 1 1h14c.553 0 1-.447 1-1V7c0-.553-.447-1-1-1zm-1 12H6v-6h12v6zm0-8H6V8h2c0 .553.447 1 1 1 .553 0 1-.447 1-1h4c0 .553.447 1 1 1 .553 0 1-.447 1-1h2v2zm-9 6c0 .553.447 1 1 1 .553 0 1-.447 1-1h2c0 .553.447 1 1 1 .553 0 1-.447 1-1 .553 0 1-.447 1-1 0-.553-.447-1-1-1 0-.553-.447-1-1-1-.553 0-1 .447-1 1h-2c0-.553-.447-1-1-1-.553 0-1 .447-1 1-.553 0-1 .447-1 1 0 .553.447 1 1 1z"
}));

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.a01fa938.svg";
export { ForwardRef as ReactComponent };